import {EUFlag, GermanyFlag, IrelandFlag, USFlag, AUFlag, HKFlag, SGFlag, ASFlag, AZFlag} from '../icons'

const regionKeys = {
    eu_central_1: 'eu-central-1',
    az_baku_1: 'az-baku-1',
    eu_west_1: 'eu-west-1',
    us_east_1: 'us-east-1',
    us_west_1: 'us-west-1',
    ap_southeast_2: 'ap-southeast-2',
    ap_southeast_4: 'ap-southeast-4',
    ap_east_1: 'ap-east-1',
    ap_southeast_1: 'ap-southeast-1'
}

const locationManager = {
    allRegions: {
        [regionKeys.eu_central_1]: {
            icon: <EUFlag/>,
            label: 'EU',
            value: regionKeys.eu_central_1,
            country: 'Europe',
            location: 'Europe'
        },
        [regionKeys.az_baku_1]: {
            icon: <AZFlag/>,
            label: 'AZ',
            value: regionKeys.az_baku_1,
            country: 'Azerbaijan',
            location: 'Azerbaijan'
        },
        [regionKeys.us_east_1]: {
            icon: <USFlag/>,
            label: 'US',
            value: regionKeys.us_east_1,
            country: 'United States',
            location: 'United States'
        },
        [regionKeys.ap_southeast_2]: {
            icon: <AUFlag/>,
            label: 'AU',
            value: regionKeys.ap_southeast_2,
            country: 'Australia',
            location: 'Australia'
        },
        [regionKeys.ap_southeast_1]: {
            icon: <ASFlag/>,
            label: 'AS',
            value: regionKeys.ap_southeast_1,
            country: 'Singapore',
            location: 'Asia'
        }
    },

    allLocations: {
        [regionKeys.eu_central_1]: {
            icon: <GermanyFlag/>,
            label: 'DE',
            value: regionKeys.eu_central_1,
            country: 'Germany',
            location: 'Frankfurt'
        },
        [regionKeys.az_baku_1]: {
            icon: <AZFlag/>,
            label: 'AZ',
            value: regionKeys.az_baku_1,
            country: 'Azerbaijan',
            location: 'Azerbaijan'
        },
        [regionKeys.us_east_1]: {
            icon: <USFlag/>,
            label: 'US',
            value: regionKeys.us_east_1,
            country: 'US',
            location: 'N.Virginia'
        },
        [regionKeys.eu_west_1]: {
            icon: <IrelandFlag/>,
            label: 'EU',
            value: regionKeys.eu_west_1,
            country: 'Ireland',
            location: 'Dublin'
        },
        [regionKeys.us_west_1]: {
            icon: <USFlag/>,
            label: 'US',
            value: regionKeys.us_west_1,
            country: 'US',
            location: 'N.California'
        },
        [regionKeys.ap_southeast_2]: {
            icon: <AUFlag/>,
            label: 'AU',
            value: regionKeys.ap_southeast_2,
            country: 'Australia',
            location: 'Sydney'
        },
        [regionKeys.ap_southeast_4]: {
            icon: <AUFlag/>,
            label: 'AU',
            value: regionKeys.ap_southeast_4,
            country: 'Australia',
            location: 'Melbourne'
        },
        [regionKeys.ap_southeast_1]: {
            icon: <SGFlag/>,
            label: 'AS',
            value: regionKeys.ap_southeast_1,
            country: 'Singapore',
            location: 'Singapore'
        },
        [regionKeys.ap_east_1]: {
            icon: <HKFlag/>,
            label: 'AS',
            value: regionKeys.ap_east_1,
            country: 'Hong Kong',
            location: 'Hong Kong'
        }
    },

    getMainLocations: function() {
        const envMainLocations = process.env.REACT_APP_MAIN_LOCATIONS
        if (envMainLocations) {
            return envMainLocations.split(',').map(region => this.allRegions[region])
        }

        return [
            this.allRegions[regionKeys.eu_central_1],
            this.allRegions[regionKeys.us_east_1],
            this.allRegions[regionKeys.ap_southeast_2],
            this.allRegions[regionKeys.ap_southeast_1]
        ]
    },

    getRegionByCustomerCountryCode(customerCountry) {
        const regionsByCustomerCountry = {
            'US': this.allRegions[regionKeys.us_east_1],
            'CA': this.allRegions[regionKeys.us_east_1],
            'MX': this.allRegions[regionKeys.us_east_1],
            'BS': this.allRegions[regionKeys.us_east_1],
            'CU': this.allRegions[regionKeys.us_east_1],
            'BB': this.allRegions[regionKeys.us_east_1],
            'CO': this.allRegions[regionKeys.us_east_1],
            'JM': this.allRegions[regionKeys.us_east_1],
            'HT': this.allRegions[regionKeys.us_east_1],
            'DO': this.allRegions[regionKeys.us_east_1],
            'BM': this.allRegions[regionKeys.us_east_1],
            'KY': this.allRegions[regionKeys.us_east_1],
            'VG': this.allRegions[regionKeys.us_east_1],
            'GT': this.allRegions[regionKeys.us_east_1],
            'BZ': this.allRegions[regionKeys.us_east_1],
            'HN': this.allRegions[regionKeys.us_east_1],
            'SV': this.allRegions[regionKeys.us_east_1],
            'NI': this.allRegions[regionKeys.us_east_1],
            'CR': this.allRegions[regionKeys.us_east_1],
            'PA': this.allRegions[regionKeys.us_east_1],
            'AU': this.allRegions[regionKeys.ap_southeast_2],
            'NZ': this.allRegions[regionKeys.ap_southeast_2],
            'ID': this.allRegions[regionKeys.ap_southeast_2],
            'PG': this.allRegions[regionKeys.ap_southeast_2],
            'TL': this.allRegions[regionKeys.ap_southeast_2],
            'SB': this.allRegions[regionKeys.ap_southeast_2],
            'TO': this.allRegions[regionKeys.ap_southeast_2],
            'WS': this.allRegions[regionKeys.ap_southeast_2],
            'KI': this.allRegions[regionKeys.ap_southeast_2],
            'TV': this.allRegions[regionKeys.ap_southeast_2],
            'NR': this.allRegions[regionKeys.ap_southeast_2],
            'SG': this.allRegions[regionKeys.ap_southeast_2],
            'VU': this.allRegions[regionKeys.ap_southeast_2],
            'NC': this.allRegions[regionKeys.ap_southeast_2],
            'FJ': this.allRegions[regionKeys.ap_southeast_2],
            'FM': this.allRegions[regionKeys.ap_southeast_2],
            'CK': this.allRegions[regionKeys.ap_southeast_2],
            'PW': this.allRegions[regionKeys.ap_southeast_2],
            'CN': this.allRegions[regionKeys.ap_southeast_1],
            'MY': this.allRegions[regionKeys.ap_southeast_1],
            'BN': this.allRegions[regionKeys.ap_southeast_1],
            'KH': this.allRegions[regionKeys.ap_southeast_1],
            'LA': this.allRegions[regionKeys.ap_southeast_1],
            'LK': this.allRegions[regionKeys.ap_southeast_1],
            'TW': this.allRegions[regionKeys.ap_southeast_1],
            'JP': this.allRegions[regionKeys.ap_southeast_1],
            'KR': this.allRegions[regionKeys.ap_southeast_1],
            'MN': this.allRegions[regionKeys.ap_southeast_1],
            'TH': this.allRegions[regionKeys.ap_southeast_1],
            'MM': this.allRegions[regionKeys.ap_southeast_1],
            'NP': this.allRegions[regionKeys.ap_southeast_1],
            'KG': this.allRegions[regionKeys.ap_southeast_1],
            'KZ': this.allRegions[regionKeys.ap_southeast_1],
            'PH': this.allRegions[regionKeys.ap_southeast_1],
            'VN': this.allRegions[regionKeys.ap_southeast_1],
            'BD': this.allRegions[regionKeys.ap_southeast_1],
            'AF': this.allRegions[regionKeys.ap_southeast_1],
            'BH': this.allRegions[regionKeys.ap_southeast_1],
            'BT': this.allRegions[regionKeys.ap_southeast_1],
            'CY': this.allRegions[regionKeys.ap_southeast_1],
            'GE': this.allRegions[regionKeys.ap_southeast_1],
            'IN': this.allRegions[regionKeys.ap_southeast_1],
            'IR': this.allRegions[regionKeys.ap_southeast_1],
            'IQ': this.allRegions[regionKeys.ap_southeast_1],
            'JO': this.allRegions[regionKeys.ap_southeast_1],
            'KW': this.allRegions[regionKeys.ap_southeast_1],
            'LB': this.allRegions[regionKeys.ap_southeast_1],
            'MV': this.allRegions[regionKeys.ap_southeast_1],
            'OM': this.allRegions[regionKeys.ap_southeast_1],
            'PK': this.allRegions[regionKeys.ap_southeast_1],
            'PS': this.allRegions[regionKeys.ap_southeast_1],
            'QA': this.allRegions[regionKeys.ap_southeast_1],
            'SA': this.allRegions[regionKeys.ap_southeast_1],
            'SY': this.allRegions[regionKeys.ap_southeast_1],
            'TJ': this.allRegions[regionKeys.ap_southeast_1],
            'TM': this.allRegions[regionKeys.ap_southeast_1],
            'AE': this.allRegions[regionKeys.ap_southeast_1],
            'UZ': this.allRegions[regionKeys.ap_southeast_1],
            'YE': this.allRegions[regionKeys.ap_southeast_1],
            'AZ': this.allRegions[regionKeys.ap_southeast_1]
        }

        return regionsByCustomerCountry[customerCountry] || this.getDefaultRegion()
    },

    getDefaultRegion() {
        const envDefaultRegion = process.env.REACT_APP_DEFAULT_REGION
        return this.allRegions[envDefaultRegion] || this.allRegions[regionKeys.eu_central_1]
    }
}

export {locationManager, regionKeys}
